import React, { useEffect, useState } from 'react';
import { Card, Form, Input, Button, message } from 'antd';
import { SettingOutlined, ReloadOutlined } from '@ant-design/icons';
import MainLayout from '../../layouts/MainLayout';
import { companySettingsApi, show422Error } from '../../utils/api';
import { PANEL_PRIMARY_BTN_CLASS } from '../../constants/ui';

const CompanySettings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [companyId, setCompanyId] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await companySettingsApi.get();
      const company = res?.company || res?.data?.company || {};
      setCompanyId(company?.id || null);
      form.setFieldsValue({
        company_name: company?.company_name || '',
        company_email: company?.company_email || '',
        company_phone: company?.company_phone || '',
        website: company?.website || '',
      });
    } catch (error) {
      message.error(error?.message || 'خطا در دریافت تنظیمات شرکت');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (values) => {
    if (!companyId) return;
    setSubmitting(true);
    try {
      await companySettingsApi.update(companyId, values);
      message.success('تنظیمات شرکت بروزرسانی شد');
      fetchData();
    } catch (error) {
      if (error?.name === 'ValidationError' || error?.details) show422Error(error, form);
      else message.error(error?.message || 'خطا در ذخیره تنظیمات');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MainLayout>
      <div className="custom-font" style={{ fontFamily: 'CustomFont' }}>
        <Card className="shadow-xl border-0" bodyStyle={{ padding: 0 }}>
          <div className="flex items-center justify-between flex-wrap gap-4 p-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gray-100 dark:bg-gray-700/70 flex items-center justify-center">
                <SettingOutlined className="text-gray-700 dark:text-gray-300 text-xl" />
              </div>
              <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 m-0">تنظیمات شرکت</h1>
            </div>
            <Button icon={<ReloadOutlined />} onClick={fetchData} loading={loading}>
              بروزرسانی
            </Button>
          </div>

          <div className="p-6 bg-gray-50 dark:bg-gray-900/50 rounded-b-xl">
            <Card className="shadow-sm border border-gray-100 dark:border-gray-700 bg-white dark:bg-gray-800">
              <Form
                form={form}
                layout="vertical"
                onFinish={onSubmit}
                className="custom-font"
                disabled={loading}
              >
                <Form.Item name="company_name" label="نام شرکت">
                  <Input />
                </Form.Item>
                <Form.Item name="company_email" label="ایمیل شرکت">
                  <Input />
                </Form.Item>
                <Form.Item name="company_phone" label="تلفن شرکت">
                  <Input />
                </Form.Item>
                <Form.Item name="website" label="وب‌سایت">
                  <Input />
                </Form.Item>
                <Form.Item className="mb-0">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={submitting}
                    className={PANEL_PRIMARY_BTN_CLASS}
                  >
                    ذخیره تغییرات
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default CompanySettings;
